import { get } from 'lodash';
import { GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT } from 'Store/booking/additional-accommodations/additionalAccommodations.action';
import { getFiltersAndAlternativesByComfort } from 'Store/filteredAccommodationsByComfort/filteredAccommodationsByComforHelper';
type State = Array<any> | null | undefined;
const initialState: State = null;

function filteredAccommodationsAlternativesByComfortReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  const additionalAccommodations = get(action, 'payload.additionalAccommodations') || [];

  switch (get(action, 'type')) {
    case GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT:
      return getFiltersAndAlternativesByComfort(additionalAccommodations);

    default:
      return state;
  }
}

export default filteredAccommodationsAlternativesByComfortReducer;
